module.exports = __webpack_public_path__ + "img/sent-message.8f9c05f1.svg";